import React from 'react';
import I18n from '../i18n';
import PropTypes from 'prop-types';
import defaultIcon from '../../static/images/vht_logo_white.svg';
import Group from './group';
import NavItem from './nav-item';
import statuses from './statuses';

export default function NavigationApplication(props) {
  const {selected, onOpenToggled, open} = props;
  const {id, icon, name, children} = props.app;
  const translatedName = I18n.t(name);
  const wrapperRef = React.useRef(null);
  const ulRef = React.useRef(null);
  const [status, setStatus] = React.useState(statuses.ok);
  const navItemStatuses = React.useMemo(() => ({}), []);

  const setNavItemStatus = React.useCallback((navItemId, navItemStatus) => {
    let appStatus = statuses.severity.indexOf('ok');
    navItemStatuses[navItemId] = navItemStatus;
    Object.values(navItemStatuses).forEach(s => {
      if (statuses.severity.indexOf(s) > appStatus) {
        appStatus = statuses.severity.indexOf(s);
      }
    });
    setStatus(statuses.severity[appStatus]);
  });

  React.useEffect(() => {
    setHeight();
  }, [open]);

  function renderApplicationChild(child, childIdx) {
    return child.children ? (
      <Group applicationId={id} key={`${id}.${childIdx}`} navData={child} onStatusChange={setNavItemStatus} />
    ) : (
      <NavItem key={`${id}.${childIdx}`} navData={child} onStatusChange={setNavItemStatus} />
    );
  }

  function setHeight() {
    const panelHeight = ulRef.current.offsetHeight;
    const newHeight = open ? panelHeight : 0;

    wrapperRef.current.style.height = `${newHeight}px`;
  }

  function toggleOpen() {
    if (onOpenToggled) {
      onOpenToggled(id);
    }
  }

  return (
    <div className={`application ${selected ? 'selected' : ''} status-${status}`} key={id}>
      <div className="name" onClick={clickEvent => toggleOpen(clickEvent, id)}>
        <img src={icon ? icon : defaultIcon} alt={translatedName} aria-hidden="true" />
        <span>
          <I18n t={name} />
        </span>
      </div>
      <div className="wrapper" ref={wrapperRef}>
        <ul ref={ulRef}>{children.map(renderApplicationChild)}</ul>
      </div>
    </div>
  );
}

NavigationApplication.defaultProps = {
  open: false,
  selected: false,
};

NavigationApplication.propTypes = {
  /** The application data to display. */
  app: PropTypes.object.isRequired,
  /** Whether or not this application is open by default. */
  open: PropTypes.bool,
  /** A callback function to execute when this application is opened. */
  onOpenToggled: PropTypes.func,
  /** Whether or not this application is selected by default. */
  selected: PropTypes.bool,
};
